import { gql } from "@apollo/client";

export const GET_ALL_FRANJA_ETARIA = gql`
query GetAllFranjaEtaria {
    allFranjaEtaria{
            id,
            descripcion
      }
}`;